import List from '../../../../../components/Purchasing/Remittance/AddRemittance/Lines/List'
import RemittanceLinesModal from '../../../../../components/Purchasing/Remittance/AddRemittance/Lines/RemittanceLinesModal'
import React, { Fragment } from 'react'

function RemittanceLines (props) {
  return (
    <Fragment>
      <RemittanceLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default RemittanceLines
